/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { styled, 
  Button, 
  Card, 
  Menu, 
} from "@mui/material";
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';

export const StyledUserButton = styled(Button)({
  '&:hover': {
    backgroundColor: '#f0f0f0',
    color: '#282828'
  },
  textTransform: 'none',
  color: '#727272',
  padding: '12px 15px 10px 15px',
  borderRadius: '10px',
  fontSize: '14px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
})

export const StyledAccountIcon = styled(AccountCircleOutlinedIcon)({
  fontSize: '30px !important',
  marginTop: '-4px !important',
})

export const NavbarActions = styled(Card)({
  display: "flex",
  flexDirection: "row",
  height: "50px !important",
  gap: '2%',
  alignItems: 'center',
})

export const StyledMenu = styled(Menu)({
  '& .MuiPaper-root': {
    borderRadius: '10px', 
    boxShadow: 'rgba(0, 0, 0, 0.14) 0px 3px 8px !important',
    minWidth: '10%'
  }
})

export const StyledToggleButton = styled(Button)({
  '&:hover':{
    backgroundColor: 'white !important',
  },
  borderRadius: '80px',
  color: '#666666',
})

export const desktopImageStyles = {
  width: "270px",
  height: "60px",
  marginLeft: "-22px",
}

export const mobileImageStyles = {
  width: '40px',
  height: '40px',
}
